var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "image-upload" }, [
    _c(
      "span",
      { staticClass: "label", class: _vm.state },
      [
        _c("input", {
          ref: "input",
          attrs: {
            type: "file",
            disabled: _vm.state === "saving",
            multiple: "",
            accept: _vm.accept
          },
          on: {
            change: function($event) {
              _vm.dropped($event.target.files)
            }
          }
        }),
        _vm._v(" "),
        _vm.srcs && _vm.srcs.length && _vm.accept === "image/*"
          ? _vm._l(_vm.srcs, function(src) {
              return _c("img", {
                attrs: { src: src },
                on: {
                  load: function($event) {
                    _vm.loaded(src)
                  }
                }
              })
            })
          : [
              _c("Icon", {
                staticClass: "placeholder",
                attrs: { name: "image" }
              }),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("trans")("images:upload.drop")) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(" "),
                _c("small", [
                  _vm._v(_vm._s(_vm._f("trans")("images:upload.or")))
                ])
              ])
            ]
      ],
      2
    ),
    _vm._v(" "),
    _vm.state === "saving"
      ? _c("p", [_vm._v(_vm._s(_vm._f("trans")("images:upload.wait")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.state === "ready"
      ? _c("a", { staticClass: "btn lg" }, [
          _vm._v(_vm._s(_vm._f("trans")("images:upload.select")))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b165620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b165620","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/interact/FileUpload.vue
// module id = null
// module chunks = 